import { motion } from 'framer-motion';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../../constants/svgIcon';
import { GameActionButton, SvgIcon } from '../../../Molecules';
import {
  GameStartInfoBoard,
  GameStartInfoBoardProps,
  GameStartVSBoard,
  GameStartVSBoardProps,
} from '../../../Organisms';

import './GameStartTemplate.css';

type GameStartTemplateProps = {
  gameStartInfoBoardProps: GameStartInfoBoardProps;
  gameStartVSBoardProps: GameStartVSBoardProps;
  onClickStart: () => void;
};

const GameStartTemplate = memo(
  ({
    gameStartInfoBoardProps,
    gameStartVSBoardProps,
    onClickStart,
  }: GameStartTemplateProps) => {
    const { t } = useTranslation();
    return (
      <div className="game-start-template">
        <div className="page-header">
          <motion.div
            whileTap={{ opacity: 0.8 }}
            className="back-icon"
            onClick={() => history.back()}
          >
            <SvgIcon name={SVGIconType.CircleBack} width={44} height={44} />
          </motion.div>
        </div>
        <GameStartInfoBoard {...gameStartInfoBoardProps} />
        <br />
        <GameStartVSBoard {...gameStartVSBoardProps} />
        <br />
        <div className="button-group">
          <GameActionButton
            onClick={onClickStart}
            leading={
              <SvgIcon
                name={SVGIconType.Game}
                width={24}
                height={24}
                stroke="white"
              />
            }
            trailing={
              <SvgIcon
                name={SVGIconType.Play}
                width={24}
                height={24}
                stroke="white"
              />
            }
          >
            <p style={{ padding: '0 1rem' }}>{t('Play')}</p>
          </GameActionButton>
        </div>
      </div>
    );
  },
);

export default GameStartTemplate;
